import KeyValuePair from '@/modules/core/support/KeyValuePair';

export default class OmnisearchResultItem {
    public id = 0
    public title = ''
    public attributes: KeyValuePair = {}

    /**
     * Crea una entidad en base a los datos planos obtenidos de la API
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            id: data.id,
            title: data.title || '',
            attributes: data.attributes || {},
        })
    }
}
